import { Paper, alpha, useTheme } from '@mui/material';
import { ReactNode } from 'react';

interface AuthCardProps {
  children: ReactNode;
  elevation?: number;
}

const AuthCard = ({ children, elevation = 0 }: AuthCardProps) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={elevation}
      sx={{
        borderRadius: 3,
        overflow: 'hidden',
        boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
        border: `1px solid ${alpha(theme.palette.divider, 0.5)}`,
        background: theme.palette.background.paper,
      }}
    >
      {children}
    </Paper>
  );
};

export default AuthCard;
